import React, { Component } from 'react';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import './contact.css';

const offices = [
    {
        key: 'denpasar',
        city: 'Denpasar',
        title: 'Denpasar, Bali',
        hq: 'HEADQUARTERS',
        address: 'Jalan Buluh Indah 56, Pemecutan Kaja, Denpasar Utara, Bali 80118',
        hours: 'Senin - Sabtu: 09:00 - 18:00 WITA',
        phone: '0812 3843 1234',
        map: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3944.5492299174907!2d115.19452601411855!3d-8.63919829023127!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2dd23f4e5c54e043%3A0xbf4bc0b6d7634e96!2sNaresy%20International%20Education%20Consultant%20(NIEC)%20Bali!5e0!3m2!1sen!2sid!4v1656039400954!5m2!1sen!2sid',
        directions: 'https://goo.gl/maps/QkZ9m3Z3Z3Z3Z3Z3Z',
    },
    {
        key: 'jakarta',
        city: 'Jakarta',
        title: 'Jakarta',
        hq: 'BRANCH',
        address: 'Jl. TB Simatupang No.17, RT.6/RW.9, Cilandak Bar., Kec. Cilandak, Kota Jakarta Selatan, Daerah Khusus Ibukota Jakarta 12430',
        hours: 'Senin - Jumat: 08:00 - 17:00 WIB',
        phone: '0812 3843 1234',
        map: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3965.7887336896415!2d106.79711157510518!3d-6.291474361579175!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f1e67386faf1%3A0x20d6d99d46f69f7b!2sMULA%20by%20Galeria%20Jakarta!5e0!3m2!1sen!2sid!4v1762427775295!5m2!1sen!2sid',
        directions: 'https://maps.app.goo.gl/ermxnNY7hVxXNkte7',
    },
    {
        key: 'tangerang',
        city: 'Tangerang',
        title: 'Tangerang',
        hq: 'BRANCH',
        address: 'Ruko Emerald Boulevard Bintaro Sektor 9 Blok AA2. 50, Parigi, Pondok Aren, South Tangerang City, Banten 15227',
        hours: 'Senin - Jumat: 08:00 - 17:00 WIB',
        phone: '0813 9804 8335',
        map: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3965.8618207724458!2d106.6999211751051!3d-6.28188956149032!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69fb0336322c5b%3A0x4be09f3887141156!2sSanctuary%20Bintaro!5e0!3m2!1sen!2sid!4v1762427437952!5m2!1sen!2sid',
        directions: 'https://maps.app.goo.gl/LUExuX89nKjMJ8MPA',
    },
    {
        key: 'bandung',
        city: 'Bandung',
        title: 'Bandung',
        hq: 'BRANCH',
        address: 'Jl. Banda No.30, Citarum, Kec. Bandung Wetan, Kota Bandung, Jawa Barat 40115',
        hours: 'Senin - Jumat: 08:00 - 17:00 WIB',
        phone: '0812 3843 1234',
        map: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3960.8686320318275!2d107.6146806751131!3d-6.906308367589909!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e68e735d8dcb58b%3A0x335e6971ca0816c8!2sPoint%20Lab%20Co-working%20Space!5e0!3m2!1sen!2sid!4v1762428054509!5m2!1sen!2sid',
        directions: 'https://maps.app.goo.gl/yDxEdLjjcowLxNo98',
    },
    {
        key: 'medan',
        city: 'Medan',
        title: 'Medan',
        hq: 'BRANCH',
        address: 'Sinar Mas Land Plaza, Jl. Pangeran Diponegoro No.18 10th Floor, Madras Hulu, Kec. Medan Polonia, Kota Medan, Sumatera Utara 20152',
        hours: 'Senin - Jumat: 08:00 - 17:00 WIB',
        phone: '0812 3843 1234',
        map: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3982.0186342771735!2d98.6724624!3d3.5831947!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3031316bc6f910b7%3A0x7006547214d977e!2sGoWork%20Sinar%20Mas%20Land%20Plaza%20Medan%20-%20Coworking%20And%20Office%20Space!5e0!3m2!1sen!2sid!4v1780243962573!5m2!1sen!2sid',
        directions: 'https://maps.app.goo.gl/6iafDT2aVL3PHCa58',
    },
    {
        key: 'yogyakarta',
        city: 'Yogyakarta',
        title: 'Yogyakarta',
        hq: 'BRANCH',
        address: 'Jl. Bintaran Kidul No.36, Wirogunan, Kec. Mergangsan, Kota Yogyakarta, Daerah Istimewa Yogyakarta 55151',
        hours: 'Senin - Jumat: 08:00 - 17:00 WIB',
        phone: '0812 3843 1234',
        map: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3952.8727110149416!2d110.37242119999999!3d-7.8032979000000005!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e7a5783771c1d29%3A0x67b87f6980e74aac!2sNaresy%20International%20Education%20Consultant%20(NIEC)%20Yogyakarta!5e0!3m2!1sen!2sid!4v1780308731845!5m2!1sen!2sid',
        directions: 'https://maps.app.goo.gl/ziVvfBuV9Y4WXwKa9',
    },
    {
        key: 'surabaya',
        city: 'Surabaya',
        title: 'Surabaya',
        hq: 'BRANCH',
        address: 'VOZA TOWER, Jl. Mayjen HR. Muhammad No.31, Putat Gede, Kec. Sukomanunggal, Surabaya, Jawa Timur 60189',
        hours: 'Senin - Jumat: 08:00 - 17:00 WIB',
        phone: '0812 3843 1234',
        map: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3957.596941703788!2d112.69662087511826!3d-7.2866152716165!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2dd7fde762e2f383%3A0x54caa19102a96f9d!2sIdeaHub%20Coworking%20Space!5e0!3m2!1sen!2sid!4v1762427953834!5m2!1sen!2sid',
        directions: 'https://maps.app.goo.gl/vC46Qygv22w7hWNY9',
    },
    {
        key: 'makassar',
        city: 'Makassar',
        title: 'Makassar',
        hq: 'BRANCH',
        address: 'Panaikang, Panakkukang, Makassar City, South Sulawesi 90231',
        hours: 'Senin - Jumat: 08:00 - 17:00 WIB',
        phone: '0812 3843 1234',
        map: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3973.780331838454!2d119.44720067509179!3d-5.139035351974816!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2dbefd5f657e5e37%3A0x74c1ebaf12decb1b!2sBikin%20Bikin%20Creative%20Hub!5e0!3m2!1sen!2sid!4v1762427647539!5m2!1sen!2sid',
        directions: 'https://maps.app.goo.gl/Hch5Z9nKDfp6BEya9',
    },
];

const HeroSection = () => {
    return (
        <section className="contact-hero-section">
            <img className="contact-hero-bg" src="assets/img/slide/contacus/contactus.jpg" alt="Contact Us" onError={(e) => { e.target.onerror = null; e.target.src = '../../../assets/img/slide/contacus/contactus.jpg' }} />
            <div className="contact-hero-overlay">
                <div className="container position-relative z-index-2">
                    <div className="row">
                        <div className="col-lg-6 contact-hero-content animate__animated animate__fadeInLeft">
                            <div className="hero-badge-connect">CONNECT GLOBALLY</div>
                            <h1 className="hero-title-white">Contact Our</h1>
                            <h1 className="hero-title-red">Global Experts</h1>
                            <p className="hero-subtitle mt-3">
                                Perjalanan Anda menuju pendidikan kelas dunia dimulai dari satu percakapan. Hubungi konsultan kami untuk mendapatkan bimbingan personal mengenai masa depan akademik Anda.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

const StatsSection = () => {
    return (
        <section className="stats-section">
            <div className="container">
                <div className="row g-4">
                    <div className="col-md-4 animate__animated animate__fadeInUp">
                        <div className="stat-card-pink">
                            <div className="stat-number">15+</div>
                            <div className="stat-title">YEARS OF EXPERIENCE</div>
                            <div className="stat-desc">Menyediakan layanan konsultasi pendidikan luar negeri sejak 2009.</div>
                        </div>
                    </div>
                    <div className="col-md-4 animate__animated animate__fadeInUp" style={{ animationDelay: '0.1s' }}>
                        <div className="stat-card-pink">
                            <div className="stat-number">500+</div>
                            <div className="stat-title">GLOBAL UNIVERSITY PARTNERS</div>
                            <div className="stat-desc">Bekerja sama dengan universitas di berbagai negara untuk menyediakan pilihan studi terbaik bagi siswa.</div>
                        </div>
                    </div>
                    <div className="col-md-4 animate__animated animate__fadeInUp" style={{ animationDelay: '0.2s' }}>
                        <div className="stat-card-pink">
                            <div className="stat-number">10k+</div>
                            <div className="stat-title">SUCCESSFUL ALUMNI</div>
                            <div className="stat-desc">Membantu ribuan siswa melanjutkan studi ke luar negeri dengan bimbingan yang tepat dan terpercaya.</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};


const FormContactSection = () => {
    return (
        <section className="form-section">
            <div className="container">
                <div className="row g-5">
                    {/* Left Col: Form */}
                    <div className="col-lg-7 mb-4 mb-lg-0">
                        <div className="form-card h-100 d-flex flex-column justify-content-center">
                            {/* <div className="form-blob"></div> */}
                            <div className="form-card-content">
                                <h3 className="form-section-title">Kirim Permintaan</h3>
                                <p className="form-section-subtitle">Ceritakan tujuan Anda, dan kami akan menghubungi Anda dalam 24 jam.</p>
                                <form action="forms/contact.php" method="post" role="form">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <input type="text" name="name" className="custom-input" placeholder="Nama" required />
                                        </div>
                                        <div className="col-md-6">
                                            <input type="email" name="email" className="custom-input" placeholder="Email Address" required />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <input type="text" name="no_hp" className="custom-input" placeholder="No.Hp" required />
                                        </div>
                                        <div className="col-md-6">
                                            <select name="pendidikan" className="custom-input" required defaultValue="">
                                                <option value="" disabled>Pendidikan Terakhir</option>
                                                <option value="SMA/SMK">SMA/SMK</option>
                                                <option value="D3/S1">D3/S1</option>
                                                <option value="S2">S2</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div>
                                        <textarea name="message" className="custom-input" rows="4" placeholder="Pesan" required></textarea>
                                    </div>
                                    <button type="submit" className="btn-red-submit mt-2">Submit Consultation Request</button>
                                </form>
                            </div>
                        </div>
                    </div>

                    {/* Right Col: Contact Info */}
                    <div className="col-lg-5 d-flex flex-column">
                        <div className="contact-info-card">
                            <h4 className="contact-info-title"><i className="bi bi-headset"></i> Kontak Kami</h4>

                            <div className="contact-item">
                                <div className="contact-icon-box"><i className="bi bi-envelope-fill"></i></div>
                                <div>
                                    <div className="contact-item-label">EMAIL US</div>
                                    <div className="contact-item-value">info@niecindonesia.com</div>
                                </div>
                            </div>

                            <div className="contact-item">
                                <div className="contact-icon-box"><i className="bi bi-telephone-fill"></i></div>
                                <div>
                                    <div className="contact-item-label">CALL CENTER</div>
                                    <div className="contact-item-value">0812 3843 1234</div>
                                </div>
                            </div>

                            <div className="contact-item mb-0">
                                <div className="contact-icon-box"><i className="bi bi-whatsapp"></i></div>
                                <div>
                                    <div className="contact-item-label">WHATSAPP</div>
                                    <div className="contact-item-value contact-item-value-red">0812 3843 1234</div>
                                </div>
                            </div>
                        </div>

                        <div className="partnership-card flex-grow-1 d-flex flex-column justify-content-center mt-3">
                            <div className="partnership-blob"></div>
                            <div style={{ position: 'relative', zIndex: 1 }}>
                                <h4 className="partnership-title">Global Partnerships</h4>
                                <p className="partnership-desc">Tertarik menjadi mitra universitas atau institusi? Kami memfasilitasi kerja sama akademik global.</p>
                                <a href="#" className="partnership-link">Partner with NIEC <i className="bi bi-arrow-right"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

const OfficesSection = () => {
    return (
        <section className="offices-section">
            <div className="container">
                <h2 className="offices-title">Our Offices</h2>
                <p className="offices-subtitle">
                    Dari kantor pusat kami di Bali hingga kantor cabang kami di seluruh Indonesia.
                </p>

                <Tabs defaultActiveKey={offices[0].key} className="custom-pill-tabs mb-4">
                    {offices.map((office) => (
                        <Tab key={office.key} eventKey={office.key} title={office.city}>
                            <OfficeMapCard office={office} />
                        </Tab>
                    ))}
                </Tabs>
            </div>
        </section>
    );
};

const OfficeMapCard = ({ office }) => {
    return (
        <div className="map-container">
            <iframe
                src={office.map}
                allowFullScreen
                loading="lazy"
            />

            <div className="map-info-card animate__animated animate__fadeInRight">
                <h4 className="map-info-title">{office.title}</h4>

                {/* <div
                    className="map-info-hq"
                    style={{ color: office.hq === 'BRANCH' ? 'transparent' : undefined }}
                >
                    {office.hq}
                </div> */}

                <div className="map-info-address">{office.address}</div>
                <div className="map-info-item">
                    <i className="bi bi-clock"></i> {office.hours}
                </div>
                <div className="map-info-item">
                    <i className="bi bi-telephone"></i> {office.phone}
                </div>

                <a
                    href={office.directions}
                    target="_blank"
                    rel="noreferrer"
                    className="get-directions-btn"
                >
                    Get Directions <i className="bi bi-geo-alt"></i>
                </a>
            </div>
        </div>
    );
};

const ContactUs = () => {
    return (
        <div>
            {/* HERO */}
            <HeroSection />

            {/* STATS */}
            <StatsSection />

            {/* FORM & CONTACT */}
            <FormContactSection />

            {/* OFFICES */}
            <OfficesSection />
        </div>
    );
};

export default ContactUs;